export const GOALS = ["Educate", "Sell", "Build Authority", "Lead Generation", "Nurture", "Conversion", "Client Update", "Onboarding", "Teardown"];
export const AUDIENCES = ["Cold", "Warm", "Client", "Team", "Leads"];
export const TONE_MODES = ["Teacher", "Consultant", "Direct", "Conversational", "Executive", "Strategic", "Story-Driven", "Analytical", "Provocative", "Empathetic"];
export const DURATIONS = [5, 10, 15, 20, 30, 60];
export const RESEARCH_MODES = [
  { value: "quick", label: "Quick Scan", help: "Fast trend + misconception scan" },
  { value: "standard", label: "Standard", help: "Balanced facts, examples, and frameworks" },
  { value: "deep", label: "Deep Dive", help: "Detailed context, trends, and strategic angles" },
];
export const DOCUMENT_PURPOSES = [
  { value: "lead_magnet", label: "Lead Magnet", help: "Value-first asset that positions you as the expert" },
  { value: "client_deliverable", label: "Client Deliverable", help: "Professional handout for active prospects or clients" },
  { value: "content_asset", label: "Content Asset", help: "Repurposable for blog, LinkedIn, Notion, or PDF" },
];

export const REWRITE_CHIPS = [
  { key: "conversational", label: "More Conversational" },
  { key: "tighten", label: "Tighten / Cut Fluff" },
  { key: "stronger_hook", label: "Stronger Hook" },
  { key: "add_example", label: "Add Example" },
  { key: "stronger_cta", label: "Stronger CTA" },
  { key: "shorten_to_time", label: "Shorten to Time" },
];

export const LOADING_MESSAGES = [
  "Mapping out your hook angles...",
  "Building the talk track framework...",
  "Writing Section 1 — framing the problem...",
  "Developing Section 2 — your solution...",
  "Crafting a real-world example...",
  "Laying out action steps...",
  "Writing CTAs and cut lines...",
  "Final polish and quality check...",
];

export const CHUNKED_LOADING_MESSAGES = [
  "Building detailed document outline for your doc...",
  "Outline ready — now writing section by section...",
  "Writing hooks — 3 unique opening angles...",
  "Framing the problem — Section 1 in progress...",
  "Building your solution walkthrough — Section 2...",
  "Crafting the example — Section 3...",
  "Writing action steps — Section 4...",
  "Finishing CTAs and cut lines...",
  "Assembling all sections together...",
  "Generating document outline...",
  "Final quality check across all sections...",
];
